<template>
    <div class="file-uploader-v2-wrapper relative mb-2">
        <label class="semibold mb-2 d-block">{{ label }}</label>

        <div class="file-uploader-v2-container relative">
            <label :for="id" :class="'file-uploader-input-v2 d-flex cursor-pointer ' + (form[id].url || form[id].incoming_url ? 'has-file' : '')">
                <input v-if="mode !== 'view'" type="file" :ref="id" @change="fileChanged" :name="id" :id="id" />
                <div class="d-flex gap-2">
                    <i v-if="form[id].url || form[id].incoming_url" class="fas fa-file-pdf"></i>
                    <i v-else class="fas fa-upload"></i>
                </div>
            </label>
            <a href="#" @click.prevent="showPdf(id)" class="mb-2 mt-2 d-block" v-if="form[id].incoming_url">View</a>
            <span v-if="mode !== 'view' && (form[id].url || form[id].incoming_url)" class="remove-file cursor-pointer" @click="removeFile(id)">
                <i class="fa fa-times" aria-hidden="true"></i>
            </span>
        </div>
        <span class="v2-file-name">{{ form[id].incoming_url == '' && form[id].url ? form[id].name : '' }}</span>
    </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
    name: 'FileUploader',
    props: {
        id: {
            type: String,
            required: true
        },

        label: {
            type: String,
            required: true
        },

        form: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            default: 'upload'
        }
    },
    mounted() {
        // console.log(this.fileObj);
    },
    methods: {
        ...mapActions({
            va_showPdf: 'pdf/setActive',
            va_setPdfObj: 'pdf/setActiveObj'
        }),
        showPdf(key) {
            this.va_showPdf(true);
            // it needds  product id {id: 1} to get value which is in form obj so fine
            this.va_setPdfObj({...this.form, ...{target_key: key}});
        },
        async fileChanged(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            // file type cehck
            if (this.$refs[this.id].files[0].type != 'application/pdf') {
                document.getElementById(this.id).value = '';
                this.$toasted.global.error({
                    message: 'Only pdf files are allowed.'
                });
                return;
            }

            // filesize prevent
            let limit5Mb = 5 * 1000000; // 5 MB limit
            if (this.$refs[this.id].files[0].size > limit5Mb) {
                document.getElementById(this.id).value = '';
                this.snackbar({
                    message: 'Sorry file cannot be more than 5MB.',
                    type: 'warning'
                });
                return;
            }
            this.form[this.id] = {
                incoming_url: '',
                url: URL.createObjectURL(files[0]),
                file: files[0],
                name: this.$refs[this.id].files[0].name,
                type: this.$refs[this.id].files[0].type,
                size: this.$refs[this.id].files[0].size
            };
        },
        removeFile(id) {
            this.form[id] = {
                incoming_url: '',
                url: '',
                file: '',
                name: '',
                type: '',
                size: ''
            };
        }
    }
};
</script>
